import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import sha256 from 'js-sha256'
import Landing from '@/components/Landing'
import Dashboard from '@/components/Dashboard'
import BlogLayout from '@/components/BlogLayout'
import Distributions from '@/components/Distributions'
import Challenges from '@/components/Challenges'
import Login from '@/components/Login'
import Artists from '@/components/Artists'
import ArtistForm from '@/components/ArtistForm'
import Labels from '@/components/Labels'
import LabelEditor from '@/components/LabelEditor'
import DistributionDetails from '@/components/DistributionDetails'
import DistributionMetadata from '@/components/DistributionMetadata'
import DistributionReopeningDetails from '@/components/DistributionReopeningDetails'
import DistributionEditor from '@/components/DistributionEditor'
import DistributionSongs from '@/components/DistributionSongs'
import DistributionCover from '@/components/DistributionCover'
import DistributionReview from '@/components/DistributionReview'
import LabelApplication from '@/components/LabelApplication'
import GlobalSearch from '@/components/GlobalSearch'
import Logout from '@/components/Logout'
import Account from '@/components/Account'
import CancelSubscription from '@/components/CancelSubscription'
import SpotifyGrowth from '@/components/SpotifyGrowth'
import Analytics from '@/components/Analytics'
import Statements from '@/components/Statements'
import StatementsNew from '@/components/StatementsNew'
import PublicPage from '@/components/PublicPage'
import UserServices from '@/components/UserServices'
import UserServicesDetail from '@/components/UserServicesDetail'
import Plans from '@/components/Plans'
import PresavePublic from '@/components/PresavePublic'
import SpotifyAuth from '@/components/SpotifyAuth'
import PresaveCampaigns from '@/components/PresaveCampaigns'
import PresaveCampaign from '@/components/PresaveCampaign'
import PodcastForm from '@/components/PodcastForm'
import Apply from '@/components/Apply'
import DistributionStores from '@/components/DistributionStores'
import LyricGenerator from '@/components/LyricGenerator'
import ProLayout from '@/components/ProLayout'
import ProWeekend from '@/components/ProWeekend'
import Receipts from '@/components/Receipts'
import Messages from '@/components/Messages'
import ServicesOnDemand from '@/components/ServicesOnDemand'
import ExtraTools from '@/components/ExtraTools'
import Forms from '@/components/Forms'
import Smartlinks from '@/components/Smartlinks'
import SmartlinkEditor from '@/components/SmartlinkEditor'
import BannerGenerator from '@/components/BannerGenerator'
import Rankings from '@/components/Rankings'
import MasteringProcess from '@/components/MasteringProcess'
import MasteringMain from '@/components/MasteringMain'
import LyricVideos from '@/components/LyricVideos'
import AICover from '@/components/AICover'
import AIBeats from '@/components/AIBeats'
import LyricVideoProcess from '@/components/LyricVideoProcess'
import MasteringPublic from '@/components/MasteringPublic'
import SpotifyPromotion from '@/components/SpotifyPromotion'
import PromoVideos from '@/components/PromoVideos'
import PublicImageUpload from '@/components/PublicImageUpload'
import Feed from '@/components/Feed'
import CustomForm from '@/components/CustomForm'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/free-music-distribution',
      name: 'LandingFree',
      component: Landing,
      meta: {
        title: 'Free music distribution for everyone.',
        title_es: 'Distribución digital gratuita para todos.',
        guest: true
      }
    },
    {
      path: '/distribucion-digital-gratuita',
      name: 'LandingFreeES',
      component: Landing,
      meta: {
        title: 'Free music distribution for everyone.',
        title_es: 'Distribución digital gratuita para todos.',
        guest: true
      }
    },
    {
      path: '/music-distribution-and-monetization',
      name: 'LandingDistribution',
      component: Landing,
      meta: {
        title: 'Free music distribution for everyone.',
        title_es: 'Distribución digital gratuita para todos.',
        guest: true
      }
    },
    {
      path: '/',
      name: 'LandingDistributionGuide',
      component: Landing,
      meta: {
        title: 'Free music distribution for everyone.',
        title_es: 'Distribución digital gratuita para todos.',
        guest: true
      }
    },
    {
      path: '/home',
      name: 'Landing',
      component: Landing,
      meta: {
        title: 'Free music distribution for everyone.',
        title_es: 'Distribución digital gratuita para todos.',
        guest: true
      }
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Landing,
      meta: {
        title: 'Terms',
        title_es: 'Términos',
        guest: true
      }
    },
    {
      path: '/playlists',
      name: 'LandingPlaylists',
      component: Landing,
      meta: {
        guest: true
      }
    },
    {
      path: '/landing/mastering',
      name: 'LandingMastering',
      component: Landing,
      meta: {
        title: 'Unlock Professional Sound Quality with AI Mastering Service - Take Your Music to the Next Level',
        description: 'Elevate your music to new heights with our AI Mastering Service. Enhance the sound quality of your tracks and unlock professional-level audio production. Experience the power of intelligent mastering technology today.',
        title_es: 'Calidad de Sonido Profesional con el Servicio de Masterización de IA: Lleva tu Música al Siguiente Nivel',
        description_es: 'Lleva tu música a otro nivel con nuestro Servicio de Masterización de IA. Mejora la calidad de sonido de tus pistas y desbloquea una producción de audio de nivel profesional. Experimenta el poder de la tecnología de masterización inteligente hoy mismo.',
        guest: true
      }
    },
    {
      path: '/public/image-upload',
      name: 'PublicImageUpload',
      component: PublicImageUpload,
      meta: {
        title: 'Image Upload for Artist Cover Image',
        guest: true
      }
    },
    {
      path: '/landing/pricing',
      name: 'LandingPricing',
      component: Landing,
      meta: {
        title: 'Monetize and sell your music everywere at no cost.',
        title_es: 'Monetiza y vende tu música en todas las plataformas digitales sin costo.',
        guest: true
      }
    },
    {
      path: '/landing/artists',
      name: 'LandingArtists',
      component: Landing,
      meta: {
        title: 'Monetize and sell your music everywere at no cost.',
        title_es: 'Monetiza y vende tu música en todas las plataformas digitales sin costo.',
        guest: true
      }
    },
    {
      path: '/our-artists',
      name: 'PublicArtists',
      component: Landing,
      meta: {
        title: 'Our Artists',
        title_es: 'Nuestros Artistas',
        guest: true
      }
    },
    {
      path: '/our-artists/:key',
      name: 'PublicArtistsDetail',
      component: Landing,
      meta: {
        title: 'Our Artists',
        title_es: 'Nuestros Artistas',
        guest: true
      }
    },
    {
      path: '/landing/labels',
      name: 'LandingLabels',
      component: Landing,
      meta: {
        title: 'Music Distribution & Analytics for Record Labels',
        title_es: 'Distribución digital & analíticas para sellos discográficos',
        guest: true
      }
    },
    {
      path: '/label-application',
      name: 'LabelApplication',
      component: LabelApplication,
      meta: {
        title: 'Application Form For Labels',
        title_es: 'Formulario de aplicación para sellos discográficos',
        guest: true
      }
    },
    {
      path: '/landing/about-us',
      name: 'LandingAbout',
      component: Landing,
      meta: {
        title: 'About Us',
        title_es: 'Sobre Nosotros',
        guest: true
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/search',
      name: 'GlobalSearch',
      component: GlobalSearch,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/pro',
      name: 'IndiefyPro',
      component: Landing,
      meta: {
        guest: true
      }
    },
    {
      path: '/record-label',
      name: 'LandingLabel',
      component: Landing,
      meta: {
        guest: true
      }
    },
    {
      path: '/feed',
      name: 'Feed',
      component: Feed,
      meta: {
        title: 'Tools to promote your music project',
        requiresAuth: true
      }
    },
    {
      path: '/tools',
      name: 'ExtraTools',
      component: ExtraTools,
      meta: {
        title: 'Tools to promote your music project',
        requiresAuth: true
      }
    },
    {
      path: '/tools/forms',
      name: 'Forms',
      component: Forms,
      meta: {
        title: 'Forms to promote your music project',
        requiresAuth: true
      }
    },
    {
      path: '/tools/smartlinks',
      name: 'Smartlinks',
      component: Smartlinks,
      meta: {
        title: 'Smartlinks',
        requiresAuth: true
      }
    },
    {
      path: '/tools/spotify-promotion',
      name: 'SpotifyPromotion',
      component: SpotifyPromotion,
      meta: {
        title: 'SpotifyPromotion',
        requiresAuth: true
      }
    },
    {
      path: '/tools/lyric-videos',
      name: 'LyricVideos',
      component: LyricVideos,
      meta: {
        title: 'AI Lyric Video Generator by Indiefy',
        requiresAuth: true
      }
    },
    {
      path: '/tools/promo-videos',
      name: 'PromoVideos',
      component: PromoVideos,
      meta: {
        title: 'Story Video Generator by Indiefy',
        requiresAuth: true
      }
    },
    {
      path: '/tools/lyric-videos/:id',
      name: 'LyricVideoPrcess',
      component: LyricVideoProcess
    },
    {
      path: '/tools/banners',
      name: 'BannerGenerator',
      component: BannerGenerator,
      meta: {
        title: 'Banner Generator',
        requiresAuth: true
      }
    },
    {
      path: '/tools/smartlinks/:id',
      name: 'SmartlinkEditor',
      component: SmartlinkEditor,
      meta: {
        title: 'Smartlink Editor',
        requiresAuth: true
      }
    },
    {
      path: '/services/music-promotion',
      name: 'SpotifyGrowth',
      component: SpotifyGrowth,
      meta: {
        title: 'Increase your monthly listeners on Spotify with this campaign.',
        guest: true
      }
    },
    {
      path: '/user/services',
      name: 'UserServices',
      component: UserServices,
      meta: {
        title: 'Low cost playlist placement and promotional campaigns',
        guest: true
      }
    },
    {
      path: '/user/services/:id',
      name: 'UserServicesDetail',
      component: UserServicesDetail,
      meta: {
        title: 'Low cost playlist placement and promotional campaigns',
        guest: true
      }
    },
    {
      path: '/tools/lyric-generator',
      name: 'LyricGenerator',
      component: LyricGenerator,
      meta: {
        title: 'Lyric Generator'
      }
    },
    {
      path: '/tools/cover-generator',
      name: 'AICover',
      component: AICover,
      meta: {
        title: 'AI Cover Generator'
      }
    },
    {
      path: '/tools/beat-generator',
      name: 'AIBeats',
      component: AIBeats,
      meta: {
        title: 'AI Beat Generator'
      }
    },
    {
      path: '/tools/mastering/:id',
      name: 'NewMastering',
      component: MasteringProcess
    },
    {
      path: '/tools/mastering',
      name: 'MasteringMain',
      component: MasteringMain
    },
    {
      path: '/distributions',
      name: 'Distributions',
      component: Distributions,
      meta: {
        title: 'Distributions',
        requiresAuth: true
      }
    },
    {
      path: '/new-distribution',
      name: 'NewDistribution',
      component: DistributionEditor,
      meta: {
        title: 'New Distribution',
        requiresAuth: true
      }
    },
    {
      path: '/new-podcast',
      name: 'NewPodcast',
      component: PodcastForm,
      meta: {
        title: 'New Podcast',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id/songs',
      name: 'DistributionSongs',
      component: DistributionSongs,
      meta: {
        title: 'Distribution Songs',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id/cover',
      name: 'DistributionCover',
      component: DistributionCover,
      meta: {
        title: 'Distribution Cover',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id/stores',
      name: 'DistributionStores',
      component: DistributionStores,
      meta: {
        title: 'Distribution Stores',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id/review',
      name: 'DistributionReview',
      component: DistributionReview,
      meta: {
        title: 'Distribution Review',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id/details',
      name: 'DistributionDetails',
      component: DistributionDetails,
      meta: {
        tab: 'details',
        title: 'Distribution Details',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id/comments',
      name: 'DistributionComments',
      component: DistributionDetails,
      meta: {
        tab: 'comments',
        title: 'Distribution Comments',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id/links',
      name: 'DistributionLinks',
      component: DistributionDetails,
      meta: {
        tab: 'links',
        title: 'Distribution Details',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id/published-stores',
      name: 'DistributionPublishedStores',
      component: DistributionDetails,
      meta: {
        tab: 'publishedStores',
        title: 'Distribution Details',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id/published-songs',
      name: 'DistributionPublishedSongs',
      component: DistributionDetails,
      meta: {
        tab: 'publishedSongs',
        title: 'Distribution Details',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id/banners',
      name: 'DistributionBanners',
      component: DistributionDetails,
      meta: {
        tab: 'banners',
        title: 'Distribution Details',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id/metadata',
      name: 'DistributionMetadata',
      component: DistributionMetadata,
      meta: {
        title: 'Distribution Metadata',
        requiresAuth: true
      }
    },
    {
      path: '/distributions/:id',
      name: 'DistributionEditor',
      component: DistributionEditor,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/artists',
      name: 'Artists',
      component: Artists,
      meta: {
        title: 'Artists',
        requiresAuth: true
      }
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: Analytics,
      meta: {
        title: 'Analytics',
        requiresAuth: true
      }
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      meta: {
        title: 'Account',
        requiresAuth: true
      }
    },
    {
      path: '/statements',
      name: 'Statements',
      component: Statements,
      meta: {
        title: 'Statements',
        requiresAuth: true
      }
    },
    {
      path: '/sales-reports',
      name: 'StatementsNew',
      component: StatementsNew,
      meta: {
        title: 'StatementsNew',
        requiresAuth: true
      }
    },
    {
      path: '/account/profile',
      name: 'Profile',
      component: Account,
      meta: {
        title: 'Profile',
        requiresAuth: true
      }
    },
    {
      path: '/account/subscription',
      name: 'Subscription',
      component: Account,
      meta: {
        title: 'Subscription',
        requiresAuth: true
      }
    },
    {
      path: '/account/validate',
      name: 'Validate',
      component: Account,
      meta: {
        title: 'Account Validation',
        requiresAuth: true
      }
    },
    {
      path: '/account/subscription/cancel',
      name: 'CancelSubscription',
      component: CancelSubscription,
      meta: {
        title: 'CancelSubscription',
        requiresAuth: true
      }
    },
    {
      path: '/artists/:id',
      name: 'Artist',
      component: ArtistForm,
      meta: {
        title: 'Artists',
        requiresAuth: true
      }
    },
    {
      path: '/artists/:id/public',
      name: 'PublicPage',
      component: PublicPage,
      meta: {
        title: 'Public Page',
        requiresAuth: true
      }
    },
    {
      path: '/tools/websites',
      name: 'Websites',
      component: PublicPage,
      meta: {
        title: 'Artist Websites',
        requiresAuth: true
      }
    },
    {
      path: '/new-artist',
      name: 'NewArtist',
      component: ArtistForm,
      meta: {
        title: 'New Artist',
        requiresAuth: true
      }
    },
    {
      path: '/labels',
      name: 'Labels',
      component: Labels,
      meta: {
        title: 'Labels',
        requiresAuth: true
      }
    },
    {
      path: '/blog',
      name: 'Blog',
      component: BlogLayout,
      meta: {
        title: 'Tips and articles to help you develop your music career',
        title_es: 'Tips y artículos para ayudarte a desarrollar tu carrera musical'
      }
    },
    {
      path: '/blog/category/:key',
      name: 'Category',
      component: BlogLayout
    },
    {
      path: '/blog/:key',
      name: 'Post',
      component: BlogLayout
    },
    {
      path: '/upgrade',
      name: 'Upgrade',
      component: Plans,
      meta: {
        title: 'Upgrade to Indiefy Pro and Get More Benefits, Promotion and Tools',
        title_es: 'Suscríbete a Indiefy Pro y obtén más beneficios, herramientas y promoción'
      }
    },
    {
      path: '/new-label',
      name: 'NewLabel',
      component: LabelEditor,
      meta: {
        title: 'New Label',
        requiresAuth: true
      }
    },
    {
      path: '/release/:key',
      name: 'PresavePublic',
      component: PresavePublic
    },
    {
      path: '/presave-campaigns',
      name: 'PresaveCampaigns',
      component: PresaveCampaigns,
      meta: {
        title: 'Presave Campaigns',
        requiresAuth: true
      }
    },
    {
      path: '/presave-campaigns/:id',
      name: 'PresaveCampaign',
      component: PresaveCampaign,
      meta: {
        title: 'Presave Campaign Details',
        requiresAuth: true
      }
    },
    {
      path: '/spotify-auth',
      name: 'SpotifyAuth',
      component: SpotifyAuth
    },
    {
      path: '/labels/:id',
      name: 'LabelEditor',
      component: LabelEditor,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/forms/:id',
      name: 'CustomForm',
      component: CustomForm,
      meta: {
        title: 'Custom Form',
        requiresAuth: true
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
      meta: {
        guest: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login',
        guest: true
      }
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: Login,
      meta: {
        title: 'Sign Up',
        guest: true
      }
    },
    {
      path: '/apply',
      name: 'Apply',
      component: Apply,
      meta: {
        title: 'Apply',
        guest: true
      }
    },
    {
      path: '/distributions/:id/reopening-details',
      name: 'DistributionReopeningDetails',
      component: DistributionReopeningDetails,
      meta: {
        title: 'Distribution Reopening Details',
        requiresAuth: true
      }
    },
    {
      path: '/free-online-music-distribution',
      name: 'DistribucionMusical',
      component: ProLayout,
      meta: {
        title_en: 'Sell your music',
        lang: 'en'
      }
    },
    {
      path: '/mastering',
      name: 'MasteringPublic',
      component: MasteringPublic,
      meta: {
        title_en: 'AI Mastering Service',
        lang: 'en'
      }
    },
    {
      path: '/distribucion-musical-gratis',
      name: 'DistribucionMusicalES',
      component: ProLayout,
      meta: {
        title_es: 'Vende tu música',
        lang: 'es'
      }
    },
    {
      path: '/pro-weekend',
      name: 'ProWeekend',
      component: ProWeekend,
      meta: {
        title: 'ProWeekend'
      }
    },
    {
      path: '/receipt/subscription/:id',
      name: 'Recepit',
      component: Receipts,
      meta: {
        title: 'Subscription receipt',
        requiresAuth: true,
        mode: 'subscription'
      }
    },
    {
      path: '/receipt/payout/:id',
      name: 'RecepitDetail',
      component: Receipts,
      meta: {
        title: 'Payout receipt',
        requiresAuth: true,
        mode: 'payout'
      }
    },
    {
      path: '/messages/all',
      name: 'Messages',
      component: Messages,
      meta: {
        title: 'All messages',
        requiresAuth: true,
        mode: 'list'
      }
    },
    {
      path: '/messages/:id',
      name: 'MessagesDetail',
      component: Messages,
      meta: {
        title: 'Message',
        requiresAuth: true,
        mode: 'detail'
      }
    },
    {
      path: '/extra-features',
      name: 'ServicesOnDemand',
      component: ServicesOnDemand,
      meta: {
        title: 'On Demand Services',
        requiresAuth: true
      }
    },
    {
      path: '/challenges',
      name: 'Challenges',
      component: Challenges,
      meta: {
        title: 'Challenges',
        requiresAuth: true
      }
    },
    {
      path: '/challenges/rankings',
      name: 'Rankings',
      component: Rankings,
      meta: {
        title: 'Rankings',
        requiresAuth: true
      }
    },
    { path: '*', redirect: '/' }
  ]
})

router.afterEach((to, from) => {
  let match = to.matched.find(record => record.meta.title)
  let lang = window.appLang
  if (match) {
    if (lang === 'es' && match.meta.title_es) {
      document.title = 'Indiefy | ' + match.meta.title_es
    } else {
      document.title = 'Indiefy | ' + match.meta.title
    }
  } else {
    if (to.meta) {
      if (to.meta.lang) {
        if (to.meta.lang === 'es' && to.meta.title_es) {
          document.title = 'Indiefy | ' + to.meta.title_es
        } else {
          document.title = 'Indiefy | ' + to.meta.title_en
        }
      }
    }
  }
})

router.beforeEach(function (to, from, next) {
  window.$('.modal').modal('hide')

  next()

  if (to.matched.some(record => record.meta.requiresAuth)) {
    axios.get(`${window.apiURL}api/user`, { withCredentials: true }).then((response) => {
      if (!window.pixelCreated || (window.$user && !window.$user._id)) {
        window.pixelCreated = true
        response.data.name = response.data.name || ''
        response.data.last_name = response.data.last_name || ''
        response.data.email = response.data.email || ''
        window.fbq('init', window.location.host.match(/localhost|staging|development/) ? '' : '901198303665932', {
          em: response.data.email ? sha256(response.data.email.toLocaleLowerCase()) : '',
          fn: response.data.name ? sha256(response.data.name.toLocaleLowerCase()) : '',
          ln: response.data.last_name ? sha256(response.data.last_name.toLocaleLowerCase()) : '',
          external_id: response.data._id
        })
      }

      if (window.$eventBus) {
        window.$eventBus.$emit('updateUser', response.data)
      }
    }, () => {
      if (!window.pixelCreated) {
        window.pixelCreated = true
        window.fbq('init', window.location.host.match(/localhost|staging|development/) ? '' : '901198303665932')
      }

      next({
        path: `/login?next=${to.fullPath}`
      })
    })
  }
})

const registerUrl = function () {
  setTimeout(() => {
    window.gtag && window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: location.pathname + location.search,
      send_to: 'UA-80876238-1'
    })
    window.gtag && window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: location.pathname + location.search,
      send_to: 'AW-877256789'
    })
    window.twq && window.twq('track', 'PageView')
  }, 1)
}

router.afterEach(function (to, from) {
  registerUrl()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js